import { render } from "./dpp-button.presentational.vue?vue&type=template&id=634baa33"
import script from "./dpp-button.presentational.vue?vue&type=script&lang=js"
export * from "./dpp-button.presentational.vue?vue&type=script&lang=js"

import "./dpp-button.presentational.vue?vue&type=style&index=0&id=634baa33&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__